import { getYouTubeVideoId } from '@/helpers/youtube-video'

export default function WorkItemDisplay({ workSample, className = '' }) {
  if (workSample.service === 'youtube') {
    const videoId = getYouTubeVideoId(workSample.serviceData)
    if (!videoId) {
      return (
        <p className="p-3 text-sm">This YouTube video link is unavailable.</p>
      )
    }
    return (
      <div className="flex min-h-0 min-w-0 flex-1 flex-col">
        <iframe
          title={workSample.name || 'YouTube work sample'}
          className={`min-h-0 w-full flex-1 overflow-hidden rounded ${className}`}
          src={`https://www.youtube.com/embed/${videoId}`}
          allowFullScreen={true}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        />
        <a
          href={`https://www.youtube.com/watch?v=${videoId}`}
          target="_blank"
          rel="noopener noreferrer"
          className="mt-2 text-sm underline"
        >
          Watch on YouTube
        </a>
      </div>
    )
  }
  return (
    <iframe
      title={workSample.name || 'Twitch work sample'}
      className={`flex flex-1 overflow-hidden rounded ${className}`}
      src={`https://player.twitch.tv/?video=${workSample.serviceData}&parent=www.gridfinder.com`}
      allowFullScreen={true}
    />
  )
}
